import { Box } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import {
  FixedBreakInputs,
  FlexibleBreakInputs,
  SemiFlexibleBreakInputs,
} from 'modules/shift_management/components/ShiftManagement/PlannedBreaks/FormInputs'
import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

interface Props {
  form: PlannedBreakForm
  validationParams: {
    startAt?: moment.Moment
    endAt?: moment.Moment
    duration?: number
  }
}
const BreakInputs = ({ form, validationParams }: Props) => {
  const error = form.validationError(validationParams)

  return (
    <Box flexDirection="row" gap="s16">
      {form.isFlexible && <FlexibleBreakInputs form={form} error={error} showNotice />}
      {form.isFixed && <FixedBreakInputs form={form} error={error} showNotice />}
      {form.isSemiFlexible && <SemiFlexibleBreakInputs form={form} error={error} />}
    </Box>
  )
}

export default observer(BreakInputs)
